import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
export function Contact() {
  return <footer id="contact" className="bg-black text-white" data-id="element-24">
      <div className="max-w-[1400px] mx-auto" data-id="element-25">
        {/* Top massive CTA area */}
        <div className="border-b-2 border-white/20 p-6 md:p-12 lg:p-24" data-id="element-26">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-6xl sm:text-8xl lg:text-[120px] font-bold leading-[0.9] tracking-tight mb-12" data-id="element-27">
            ЗВ'ЯЗАТИСЯ.
          </motion.h2>
          <p className="text-xl md:text-2xl font-medium max-w-2xl" data-id="element-28">
            Перша консультація до 5 хвилин — безкоштовна. Зателефонуйте нам, і
            ми знайдемо законне рішення вашої проблеми.
          </p>
        </div>

        {/* Grid Contact Info */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 divide-y-2 md:divide-y-0 md:divide-x-2 divide-white/20 border-b-2 border-white/20" data-id="element-29">
          <div className="p-8 lg:p-12 flex flex-col justify-between min-h-[250px] hover:bg-white hover:text-black transition-colors group" data-id="element-30">
            <h4 className="text-sm font-bold uppercase tracking-widest opacity-50 group-hover:opacity-100" data-id="element-31">
              Телефон
            </h4>
            <a href="tel:+380687870587" className="text-4xl font-bold flex items-center justify-between" data-id="element-32">
              068 787 0587
              <ArrowUpRight className="w-8 h-8 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-33" />
            </a>
          </div>

          <div className="p-8 lg:p-12 flex flex-col justify-between min-h-[250px] hover:bg-white hover:text-black transition-colors group" data-id="element-34">
            <h4 className="text-sm font-bold uppercase tracking-widest opacity-50 group-hover:opacity-100" data-id="element-35">
              Telegram
            </h4>
            <a href="https://t.me/+380687870587" target="_blank" rel="noopener noreferrer" className="text-4xl font-bold flex items-center justify-between" data-id="element-36">
              НАПИСАТИ
              <ArrowUpRight className="w-8 h-8 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-37" />
            </a>
          </div>

          <div className="p-8 lg:p-12 flex flex-col justify-between min-h-[250px] hover:bg-white hover:text-black transition-colors group" data-id="element-38">
            <h4 className="text-sm font-bold uppercase tracking-widest opacity-50 group-hover:opacity-100" data-id="element-39">
              Viber
            </h4>
            <a href="viber://chat?number=%2B380687870587" className="text-4xl font-bold flex items-center justify-between" data-id="element-40">
              НАПИСАТИ
              <ArrowUpRight className="w-8 h-8 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-41" />
            </a>
          </div>

          <div className="p-8 lg:p-12 flex flex-col justify-between min-h-[250px]" data-id="element-42">
            <h4 className="text-sm font-bold uppercase tracking-widest opacity-50" data-id="element-43">
              Локація & Графік
            </h4>
            <div className="text-lg font-medium" data-id="element-44">
              <p data-id="element-45">м. Рівне (Вся Україна)</p>
              <p className="mt-2" data-id="element-46">Пн-Пт: 09:00 - 19:00</p>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="p-6 md:p-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm font-bold uppercase tracking-widest" data-id="element-47">
          <p data-id="element-48">© {new Date().getFullYear()} ВІЙСЬКОВИЙ АДВОКАТ.</p>
          <p data-id="element-49">ВСІ ПРАВА ЗАХИЩЕНО.</p>
        </div>
      </div>
    </footer>;
}